import {DurationUnit} from '../../generated/types';
import {wordByCount} from '../utils';

/** Количество единиц длительности: «1 минута»; с upTo — в родительном падеже, для «до 1 минуты» */
export function durationUnitToString(value: number, units: DurationUnit, upTo?: boolean) {
	let words: string[] = [];
	switch (units) {
		case DurationUnit.Minute:
			words = upTo ? ['минуты', 'минут', 'минут'] : ['минута', 'минуты', 'минут'];
			break;
		case DurationUnit.Hour:
			words = upTo ? ['часа', 'часов', 'часов'] : ['час', 'часа', 'часов'];
			break;
		case DurationUnit.Day:
			words = upTo ? ['дня', 'дней', 'дней'] : ['день', 'дня', 'дней'];
			break;
		case DurationUnit.Round:
			words = ['раунд', 'раунда', 'раундов'];
			break;
	}

	return wordByCount(value, words, true);
}
